export function selectFlowTypes() {
  return (state) => state.flowTypes.current;
}